import React,
{
  useCallback,
  useMemo,
  useRef,
  useContext,
} from 'react';
import { ITableBodyProps, ITableRow } from './types';
import { TableRow } from './TableRow';
import { InvoiceHubContext } from '../../contexts/InvoiceHubContext';

const TableStyles = {
  TableTBody: '',
  TableRow: 'h-[64px]',
  TableCell: 'py-3 first:pl-6 last:pr-6 text-sm text-bw08 font-metricR last-child:w-[145px]',
};

export const TableBody = ({ columns, data }: ITableBodyProps) => {
  const columnKeys = useMemo(() => columns.map(item => item.key), [columns]);
  const observer = useRef<IntersectionObserver | null>(null);
  const contextValue = useContext(InvoiceHubContext);
  const lastRow = useCallback((callback: any) => {
    if (observer.current) observer.current?.disconnect();
    observer.current = new IntersectionObserver((entry, o) => {
      if (entry[0].isIntersecting) {
        contextValue?.fetchMoreInvoices();
        o.unobserve(entry[0].target);
      }
    }, { rootMargin: '100px', root: null, threshold: 1 });
    if (callback) observer.current?.observe(callback);
  }, [data]);
  const renderRow = (row: ITableRow, index: number) => <TableRow columnKeys={columnKeys} row={row} key={`invoice_${row?.externalId}`} lastRow={index === data.length - 1 ? lastRow : null} isLastRow={index === data.length - 1} />;

  const buildTableRows = (rows: Array<ITableRow>) => rows?.map(renderRow);

  const tableRows = buildTableRows(data);

  return (
    <tbody className={TableStyles.TableTBody}>
      {tableRows}
    </tbody>
  );
};
